import React from 'react';
import PropTypes from 'prop-types';
import DebounceInput from 'react-debounce-input';

const AutoFocusInput = ({className, placeholder, onChange, debounceTimeout = 300}) => (
  <DebounceInput
    type="text"
    className={className}
    minLength={1}
    debounceTimeout={debounceTimeout}
    placeholder={placeholder}
    onChange={(event) => onChange(event.target.value)}
    autoFocus
  />
);

AutoFocusInput.propTypes = {
  /** CSS class name(s) to apply to the input element */
  className: PropTypes.string,

  /** Placeholder text to display in the input element */
  placeholder: PropTypes.string,

  /** Function to be called when the input value changes, after debouncing */
  onChange: PropTypes.func,

  /** Debounce timeout in miliseconds */
  debounceTimeout: PropTypes.number,
};

export default AutoFocusInput;
